import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/msalConfig';

// Note: injected wallet-extension noise (MetaMask "Failed to connect") is
// suppressed by a capture-phase guard in public/index.html, which loads before
// any bundle so it wins the listener-ordering race. See that file for details.

const container = document.getElementById('root');
const root = createRoot(container);

// Temporary loading UI
root.render(<div style={{fontFamily:'sans-serif',padding:'2rem',color:'#334155'}}>Initializing authentication…</div>);

// MSAL v3 requires explicit async initialize before other API usage
msalInstance.initialize().then(() => {
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </React.StrictMode>
    );
}).catch(err => {
    console.error('MSAL initialization failed', err);
    root.render(<div style={{fontFamily:'sans-serif',padding:'2rem',color:'#b91c1c'}}>Auth initialization failed. Check console.</div>);
});